// Generated by purs version 0.11.7
"use strict";
var Control_Applicative = require("../Control.Applicative");
var Control_Bind = require("../Control.Bind");
var Control_Monad_Eff = require("../Control.Monad.Eff");
var DOM = require("../DOM");
var DOM_Node_Types = require("../DOM.Node.Types");
var Data_Array = require("../Data.Array");
var Data_Eq = require("../Data.Eq");
var Data_Function_Uncurried = require("../Data.Function.Uncurried");
var Data_Maybe = require("../Data.Maybe");
var Data_Nullable = require("../Data.Nullable");
var Data_Tuple = require("../Data.Tuple");
var Halogen_VDom_Machine = require("../Halogen.VDom.Machine");
var Halogen_VDom_Types = require("../Halogen.VDom.Types");
var Halogen_VDom_Util = require("../Halogen.VDom.Util");
var Prelude = require("../Prelude");
var VDomSpec = function (x) {
    return x;
};
var eqElemSpec = function (a, b) {
    if (Data_Eq.eq(Halogen_VDom_Types.eqElemName)(a.value1)(b.value1)) {
        if (a.value0 instanceof Data_Maybe.Just && (b.value0 instanceof Data_Maybe.Just && a.value0.value0 === b.value0.value0)) {
            return true;
        };
        if (a.value0 instanceof Data_Maybe.Nothing && b.value0 instanceof Data_Maybe.Nothing) {
            return true;
        };
        return false;
    };
    return false;
};
var buildWidget = function (v) {
    var patch = function (v1) {
        return function (v2) {
            if (v2 instanceof Halogen_VDom_Types.Grafted) {
                return patch(v1)(Halogen_VDom_Types.runGraft(v2.value0));
            };
            if (v2 instanceof Halogen_VDom_Types.Widget) {
                return function __do() {
                    var v3 = v1.value1(v2.value0)();
                    return new Halogen_VDom_Machine.Step(v3.value0, patch(v3), v3.value2);
                };
            };
            return function __do() {
                v1.value2();
                return buildVDom(v)(v2)();
            };
        };
    };
    var render = function (w) {
        return function __do() {
            var v1 = v.buildWidget(v)(w)();
            return new Halogen_VDom_Machine.Step(v1.value0, patch(v1), v1.value2);
        };
    };
    return render;
};
var buildVDom = function (spec) {
    var render = function (v) {
        if (v instanceof Halogen_VDom_Types.Text) {
            return buildText(spec)(v.value0);
        };
        if (v instanceof Halogen_VDom_Types.Elem) {
            return buildElem(spec)(v.value0)(v.value1);
        };
        if (v instanceof Halogen_VDom_Types.Keyed) {
            return buildKeyed(spec)(v.value0)(v.value1);
        };
        if (v instanceof Halogen_VDom_Types.Widget) {
            return buildWidget(spec)(v.value0);
        };
        if (v instanceof Halogen_VDom_Types.Grafted) {
            return buildVDom(spec)(Halogen_VDom_Types.runGraft(v.value0));
        };
        throw new Error("Failed pattern match at Halogen.VDom.DOM line 58, column 12 - line 63, column 44: " + [ v.constructor.name ]);
    };
    return render;
};
var buildText = function (v) {
    var done = function (node) {
        return function __do() {
            var v1 = Halogen_VDom_Util.unsafeParent(node);
            return Halogen_VDom_Util.removeChild(node, v1)();
        };
    };
    var patch = function (node, s1) {
        return function (v1) {
            if (v1 instanceof Halogen_VDom_Types.Grafted) {
                return patch(node, s1)(Halogen_VDom_Types.runGraft(v1.value0));
            };
            if (v1 instanceof Halogen_VDom_Types.Text) {
                var res = new Halogen_VDom_Machine.Step(node, patch(node, v1.value0), done(node));
                var v2 = s1 === v1.value0;
                if (v2) {
                    return Control_Applicative.pure(Control_Monad_Eff.applicativeEff)(res);
                };
                return function __do() {
                    Halogen_VDom_Util.setTextContent(v1.value0, node)();
                    return res;
                };
            };
            return function __do() {
                done(node)();
                return buildVDom(v)(v1)();
            };
        };
    };
    var render = function (s) {
        return function __do() {
            var v1 = Halogen_VDom_Util.createTextNode(s, v.document)();
            return new Halogen_VDom_Machine.Step(v1, patch(v1, s), done(v1));
        };
    };
    return render;
};
var buildKeyed = function (v) {
    var done = function (node, attrs, steps) {
        return function __do() {
            var v1 = Halogen_VDom_Util.unsafeParent(node);
            Halogen_VDom_Util.removeChild(node, v1)();
            Halogen_VDom_Util.forInE(steps, function (v2, v3) {
                return v3.value2;
            })();
            return Halogen_VDom_Machine.halt(attrs)();
        };
    };
    var patch = function (node, attrs, v1, ch1, len1) {
        return function (v2) {
            if (v2 instanceof Halogen_VDom_Types.Grafted) {
                return patch(node, attrs, v1, ch1, len1)(Halogen_VDom_Types.runGraft(v2.value0));
            };
            if (v2 instanceof Halogen_VDom_Types.Keyed && eqElemSpec(v1, v2.value0)) {
                var v3 = Data_Array.length(v2.value1);
                if (len1 === 0 && v3 === 0) {
                    return function __do() {
                        var v5 = Halogen_VDom_Machine.step(attrs)(v2.value0.value2)();
                        return new Halogen_VDom_Machine.Step(node, patch(node, v5, v2.value0, ch1, 0), done(node, v5, ch1));
                    };
                };
                var onThis = function (k, v5) {
                    return v5.value2;
                };
                var onThese = function (k, ix$prime, v5, v6) {
                    return function __do() {
                        var v7 = v5.value1(v6.value1)();
                        Halogen_VDom_Util.insertChildIx("patch", ix$prime, v7.value0, node)();
                        return v7;
                    };
                };
                var onThat = function (k, ix, v5) {
                    return function __do() {
                        var v6 = buildVDom(v)(v5.value1)();
                        Halogen_VDom_Util.insertChildIx("patch", ix, v6.value0, node)();
                        return v6;
                    };
                };
                return function __do() {
                    var v5 = Halogen_VDom_Util.diffWithKeyAndIxE(ch1, v2.value1, Data_Tuple.fst, onThese, onThis, onThat)();
                    var v6 = Halogen_VDom_Machine.step(attrs)(v2.value0.value2)();
                    return new Halogen_VDom_Machine.Step(node, patch(node, v6, v2.value0, v5, v3), done(node, v6, v5));
                };
            };
            return function __do() {
                done(node, attrs, ch1)();
                return buildVDom(v)(v2)();
            };
        };
    };
    var render = function (v1) {
        return function (ch1) {
            return function __do() {
                var v2 = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(v1.value0), v1.value1, v.document)();
                var node = DOM_Node_Types.elementToNode(v2);
                var onChild = function (k, ix, v3) {
                    return function __do() {
                        var v4 = buildVDom(v)(v3.value1)();
                        Halogen_VDom_Util.insertChildIx("render", ix, v4.value0, node)();
                        return v4;
                    };
                };
                var v3 = Halogen_VDom_Util.strMapWithIxE(ch1, Data_Tuple.fst, onChild)();
                var v4 = v.buildAttributes(v2)(v1.value2)();
                return new Halogen_VDom_Machine.Step(node, patch(node, v4, v1, v3, Data_Array.length(ch1)), done(node, v4, v3));
            };
        };
    };
    return render;
};
var buildElem = function (v) {
    var done = function (node, attrs, steps) {
        return function __do() {
            var v1 = Halogen_VDom_Util.unsafeParent(node);
            Halogen_VDom_Util.removeChild(node, v1)();
            Control_Monad_Eff.foreachE(steps)(Halogen_VDom_Machine.halt)();
            return Halogen_VDom_Machine.halt(attrs)();
        };
    };
    var patch = function (node, attrs, v1, ch1) {
        return function (v2) {
            if (v2 instanceof Halogen_VDom_Types.Grafted) {
                return patch(node, attrs, v1, ch1)(Halogen_VDom_Types.runGraft(v2.value0));
            };
            if (v2 instanceof Halogen_VDom_Types.Elem && eqElemSpec(v1, v2.value0)) {
                var v3 = Data_Array.length(v2.value1);
                var v4 = Data_Array.length(ch1);
                if (v4 === 0 && v3 === 0) {
                    return function __do() {
                        var v5 = Halogen_VDom_Machine.step(attrs)(v2.value0.value2)();
                        return new Halogen_VDom_Machine.Step(node, patch(node, v5, v2.value0, ch1), done(node, v5, ch1));
                    };
                };
                var onThis = function (ix, v5) {
                    return v5.value2;
                };
                var onThese = function (ix, v5, vdom) {
                    return function __do() {
                        var v6 = v5.value1(vdom)();
                        Halogen_VDom_Util.insertChildIx("patch", ix, v6.value0, node)();
                        return v6;
                    };
                };
                var onThat = function (ix, vdom) {
                    return function __do() {
                        var v5 = buildVDom(v)(vdom)();
                        Halogen_VDom_Util.insertChildIx("patch", ix, v5.value0, node)();
                        return v5;
                    };
                };
                return function __do() {
                    var v5 = Halogen_VDom_Util.diffWithIxE(ch1, v2.value1, onThese, onThis, onThat)();
                    var v6 = Halogen_VDom_Machine.step(attrs)(v2.value0.value2)();
                    return new Halogen_VDom_Machine.Step(node, patch(node, v6, v2.value0, v5), done(node, v6, v5));
                };
            };
            return function __do() {
                done(node, attrs, ch1)();
                return buildVDom(v)(v2)();
            };
        };
    };
    var render = function (v1) {
        return function (ch1) {
            return function __do() {
                var v2 = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(v1.value0), v1.value1, v.document)();
                var node = DOM_Node_Types.elementToNode(v2);
                var onChild = function (ix, child) {
                    return function __do() {
                        var v3 = buildVDom(v)(child)();
                        Halogen_VDom_Util.insertChildIx("render", ix, v3.value0, node)();
                        return v3;
                    };
                };
                var v3 = Halogen_VDom_Util.forE(ch1, onChild)();
                var v4 = v.buildAttributes(v2)(v1.value2)();
                return new Halogen_VDom_Machine.Step(node, patch(node, v4, v1, v3), done(node, v4, v3));
            };
        };
    };
    return render;
};
module.exports = {
    VDomSpec: VDomSpec,
    buildVDom: buildVDom,
    buildText: buildText,
    buildElem: buildElem,
    buildKeyed: buildKeyed,
    buildWidget: buildWidget
};



//////////////////
// WEBPACK FOOTER
// ./output/Halogen.VDom.DOM/index.js
// module id = 273
// module chunks = 0